<template>
  <USwitch
    v-bind="{ ...forwardedProps, ...$attrs }"
    :loading="false"
    :disabled="props.disabled || props.loading"
    class="p-switch"
    :aria-busy="props.loading || undefined"
    @update:model-value="emit('update:modelValue', $event)"
    @change="emit('change', $event)"
  >
    <template v-if="slots.label" #label="slotProps"
      ><slot name="label" v-bind="slotProps"
    /></template>
    <template v-if="slots.description" #description="slotProps"
      ><slot name="description" v-bind="slotProps"
    /></template>
  </USwitch>
</template>

<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core"
import USwitch, { type SwitchProps, type SwitchSlots } from "@nuxt/ui/components/Switch.vue"
import type { CheckboxColor } from "./checkbox-types"

const props = withDefaults(
  defineProps<
    Omit<SwitchProps, "color" | "loadingIcon" | "checkedIcon" | "uncheckedIcon"> & {
      color?: CheckboxColor
    }
  >(),
  {
    color: "secondary",
    size: "md"
  }
)
const emit = defineEmits<{
  "update:modelValue": [value: boolean]
  change: [event: Event]
}>()
const slots = defineSlots<SwitchSlots>()
// USwitch has no thumb slot. Keep its native control without introducing icon adapters.
const forwardedProps = reactiveOmit(props, "loading")
defineOptions({ inheritAttrs: false })
</script>
